"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ModalDialogManager {
    constructor(dialog) {
        this.dialog = dialog;
    }
    putDialog(dialog) {
        if (this.dialog != undefined) {
            this.dialog.object.destroy();
        }
        this.dialog = dialog;
        this.dialog.object.activate();
    }
    peekDialog() {
        return this.dialog;
    }
}
exports.default = ModalDialogManager;
